import { gql } from '@apollo/client';

export const USER_ACCOUNT_LIST = gql`
  query userAccounts {
    userAccounts {
      email
      access
      status
      source
    }
  }
`;

export const SEND_INVITES = gql`
  mutation sendInvite($emails: [String]!, $access: AccessType!, $allowedSearch: String, $allowedDashboards: [String]) {
    sendInvite(emails: $emails, access: $access, allowedSearch: $allowedSearch, allowedDashboards: $allowedDashboards) {
      email
      access
      status
    }
  }
`;

export const DASHBOARDS = gql`
  query dashboardsV2 {
    dashboardsV2 {
      name
    }
  }
`;

export const RESEND_INVITE = gql`
  mutation resendInvite($email: String!) {
    resendInvite(email: $email)
  }
`;

export const REVOKE_INVITE = gql`
  mutation revokeInvite($email: String!) {
    revokeInvite(email: $email)
  }
`;

export const REVOKE_ACCESS = gql`
  mutation revokeAccess($email: String!) {
    revokeAccess(email: $email)
  }
`;
